import { useAbility } from '@casl/react';

import type { AppAbility } from '@/authorization/app-ability';

export function useAppAbility(): AppAbility {
  return useAbility<AppAbility>();
}
